const baseFitmentFields = window.Convermax.config?.baseFitmentFields || ['Year', 'Make', 'Model'];
const extraFitmentFields = window.Convermax.config?.extraFitmentFields || ['Submodel'];
const wheelsFields = ['wheel_diameter', 'wheel_width', 'wheel_bolt_pattern'];
const tiresFields = ['tire_width', 'tire_aspect', 'tire_rim'];
const facetBarFields = [...wheelsFields, ...tiresFields];
const ignoreFields = [...facetBarFields];

const brandSelectionPageUrl = '/pages/shop-by-brand';
const collectionsPageUrl = '/collections';
const searchPageUrl = '/search';

const isDesktopWidth = window.innerWidth >= 768;

window.Convermax.facetPanelIgnoreField = (field) => {
  return (
    (window.Convermax.universalCollection && field === 'Fitment') ||
    (isDesktopWidth && facetBarFields.includes(field))
  );
};

window.Convermax.productIsNew = (publishedAt) => {
  return (Date.now() - new Date(publishedAt)) / (1000 * 60 * 60 * 24) < window.themeSettings.time_new;
};

function getPageType(defaults) {
  const {
    location: { pathname },
  } = window;

  if (pathname === collectionsPageUrl || pathname === brandSelectionPageUrl) {
    return 'parts';
  }

  return defaults.getter();
}

const getFitmentSearchTitle = () => {
  if (window.location.pathname === searchPageUrl) {
    return '';
  }

  if (window.location.href.indexOf('collections') > -1) {
    const title = document.querySelector('body#template-collection .page-title')?.textContent.trim();
    return title;
  }

  return window.location.pathname === brandSelectionPageUrl
    ? 'Brands'
    : window.location.pathname === collectionsPageUrl
      ? 'Collections'
      : '';
};

const updateCallback = () => {
  try {
    window.updateWishListButtons?.();
  } catch {}
  window.productButtonReplace?.();

  if (window._affirm_config && window.affirm?.ui) {
    window.affirm.ui.ready(function () {
      window.affirm.ui.refresh();
    });
  }
};

export default {
  platform: 'shopify',
  searchPageUrl,
  sortFields: [
    'relevance',
    'title',
    'title:desc',
    'price',
    'price:desc',
    'published_at',
    'published_at:desc',
    'collection_sort',
  ],
  SearchRequestDefaults: {
    pageSize: 36,
  },
  requestTimeout: window.Convermax.config?.requestTimeout,
  page: {
    getPageType,
  },
  fitmentSearch: {
    baseFields: baseFitmentFields,
    extraFields: extraFitmentFields,
    categorySelectionPages: [
      {
        pathname: collectionsPageUrl,
        field: window.Convermax.config?.categorySelectionPageField ?? 'category',
      },
      { pathname: brandSelectionPageUrl, field: 'vendor' },
    ],
    categorySelectionPageRedirect: window.themeSettings?.enable_ymm_redirect ?? true,
    getFitmentSearchTitle,
    isAutoRedirectDisabled: window.Convermax.config?.isAutoRedirectDisabled,
  },
  facets: {
    rangedFacet: [{ fields: ['wheel_bore'], step: '1/10//1', slider: { mode: 'LowerBound' } }],
  },
  product: {
    priceFormatter: {
      format(price) {
        // eslint-disable-next-line no-restricted-properties
        return window.Shopify.formatMoney(price * 100);
      },
    },
  },
  Widgets: [
    {
      name: 'SearchPage',
      location: '#cm_results',
      template: 'SearchPage',
    },
    {
      name: 'SearchPageHeader',
      type: 'VehicleWidget',
      location: 'body#template-search .page-title',
      template: 'fitmentSearch/pageHeader',
    },
    {
      name: 'CategoryPage',
      type: 'SearchPage',
      location: { selector: 'body#template-collection .collection-content', class: 'cm_CategoryPage pt-4' },
      template: 'CategoryPage',
    },
    {
      name: 'CategoryPageHeader',
      type: 'VehicleWidget',
      location: 'body#template-collection .page-title',
      template: 'fitmentSearch/pageHeader',
    },
    {
      name: 'FacetCategoryTiles',
      type: 'FacetTiles',
      location: 'body#template-list-collections .list-collections',
      template: 'facetTiles/hierarchicalContainer',
      isMultiLevel: window.Convermax.multiLevelCategories || false,
    },
    {
      name: 'FacetCategoryTilesPageHeader',
      type: 'VehicleWidget',
      location: 'body#template-list-collections .page-title',
      template: 'fitmentSearch/pageHeader',
    },
    {
      name: 'FacetBrandTiles',
      type: 'FacetTiles',
      location: '#cm_brands',
      template: 'facetTiles/hierarchicalContainer',
    },
    {
      name: 'FacetBrandTilesPageHeader',
      type: 'VehicleWidget',
      location: '#shopify-section-template-page-brands .page-title',
      template: 'fitmentSearch/pageHeader',
    },
    {
      name: 'SearchResult',
      updateCallback,
    },
    {
      name: 'SearchHeader',
      sortSelectClass: 'text-secondary py-1 pl-2 pr-4',
    },
    {
      name: 'SearchBox',
      location: '#header-searchbar',
      template: 'SearchBox',
    },
    {
      name: 'SearchBoxDialogButton',
      location: {
        replace: '#nav-link-search',
        class: 'text-secondary text-decoration-none',
        wrapper: 'a',
      },
      template: 'searchBox/dialogButtonMobile',
    },
    {
      name: 'Garage',
      location: { replace: '#cm_Garage', class: 'nav-item d-none d-lg-block mr-4', wrapper: 'li' },
      template: 'fitmentSearch/garage',
    },
    {
      name: 'MobileGarage',
      type: 'SingleVehicleGarage',
      location: {
        replace: '#cm_mGarage',
        class: 'nav-item d-lg-none nav-link text-secondary cm_garage-mobile',
        wrapper: 'li',
      },
      template: 'fitmentSearch/singleVehicleGarage',
    },
    {
      name: 'HomeVehicleWidget',
      type: 'VehicleWidget',
      location: 'body#template-index .ymm-bar',
      template: 'fitmentSearch/homeVehicleWidget',
    },
    {
      name: 'CategoryVehicleWidget',
      type: 'VehicleWidget',
    },
    {
      name: 'SearchVehicleWidget',
      type: 'VehicleWidget',
    },
    {
      name: 'VerifyFitment',
      location: { replace: '#cm_VerifyFitment' },
      template: 'fitmentSearch/verifyFitment',
    },
    {
      name: 'FitmentTableTabDesktop',
      type: 'FitmentTable',
      location: '#cm_fitment-table_tab',
      template: 'fitmentSearch/fitmentTableTabDesktop',
    },
    {
      name: 'FitmentTableTabMobile',
      type: 'FitmentTable',
      location: '#product-accordion-heading-fitment-table',
      template: 'fitmentSearch/fitmentTableTabMobile',
    },
    {
      name: 'FitmentTable',
      location: '.tab-content #cm_fitmentTable',
      template: 'fitmentSearch/fitmentTable',
    },
    {
      name: 'MobileFitmentTable',
      type: 'FitmentTable',
      location: '.product-accordion #cm_fitmentTable',
      template: 'fitmentSearch/fitmentTable',
    },
    {
      name: 'FacetPanel',
      ignoreFields,
    },
    {
      name: 'FacetBarWheels',
      type: 'FacetBar',
      fields: wheelsFields,
    },
    {
      name: 'FacetBarTires',
      type: 'FacetBar',
      fields: tiresFields,
    },
    {
      name: 'FacetDialog',
      template: 'FacetDialog',
      ignoreFields,
    },
    {
      name: 'SearchBoxDialog',
      template: 'SearchBoxDialog',
    },
    {
      name: 'VehicleWidgetDialog',
      location: { class: 'vehicle-dialog align-items-center justify-content-center' },
      template: 'fitmentSearch/dialog',
      doNotRedirectOnVehicleSelect: true,
    },
  ],
};
